import React, { useState } from 'react';
import { useEffect } from 'react';
import { useCallback } from 'react';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Grid,
  Typography,
  createStyles,
  makeStyles,
} from '@material-ui/core';

import { ReactComponent as Checked } from '../../../../assets/img/Checked.svg';
import WhatsappDialog from '../../../../components/CommonDialogs/WhatsappDialog.component';
import SubHeader from '../../../../components/Header/SubHeader.component';
import Loader from '../../../../components/LoaderSplash/Loader.component';
import SuraCard from '../../../../components/SuraCard';
import { useAuthDataContext } from '../../../../context/auth/auth.provider';
import { useEndorsementsDataContext } from '../../../../context/endorsements/endorsements.provider';
import { dataLayerPush } from '../../../../helpers/dataLayerPush';
import {
  POLICIES_QUERY,
  POLICIES_QUERY_CONFIG,
  policiesQuery,
} from '../../../../query/policies/policies';
import {
  PRODUCTS_QUERY,
  PRODUCTS_QUERY_CONFIG,
  productsQuery,
} from '../../../../query/products/products';
import Products from './Products.component';

const useStyle = makeStyles(() =>
  createStyles({
    selectionCard: {
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
      cursor: 'pointer',
      '& img': {
        maxWidth: '60px',
        height: '30px',
      },
    },
    borderedCard: {
      border: '1px solid #FA6400',
    },
    check: {
      position: 'absolute',
      top: '5%',
      right: '5%',
    },
    checked: {
      '& path': {
        stroke: '#FA6400',
      },
    },
  })
);

const ModifiedPayments = () => {
  const [listProducts, setListProducts] = useState(false);
  const [productsF, setProductsF] = useState<any[]>([]);
  const [policySelected, setPolicySelected] = useState<any>();
  const [selected, setSelected] = useState(false);
  const classes = useStyle();
  const history = useHistory();
  const { updateEndorsementBody } = useEndorsementsDataContext();
  const { user } = useAuthDataContext();

  const { data: policies, isLoading: loading } = useQuery(
    [POLICIES_QUERY, { name: 'product_codes', value: productsF.join(',') }],
    policiesQuery,
    POLICIES_QUERY_CONFIG
  );

  const { data: products, isLoading: loadingP } = useQuery(
    PRODUCTS_QUERY,
    productsQuery,
    PRODUCTS_QUERY_CONFIG
  );

  useEffect(() => {
    if (products && products.length > 1) {
      setListProducts(true);
    }
  }, [products]);

  const filterProduct = useCallback((productsFilter) => {
    setProductsF(productsFilter);
  }, []);

  const finishSelection = useCallback(
    (selectedProducts) => {
      dataLayerPush('cuenta_modificar_pago_productos', user?.id, {
        fieldName: 'params',
        fieldValue: selectedProducts,
      });
      setListProducts(false);
      dataLayerPush('cuenta_modificar_pago_poliza', user?.id);
    },
    [user]
  );

  const handleContinue = () => {
    updateEndorsementBody({ policySelected });
    history.push('/edit_payment_method/' + policySelected?.id);
  };

  const selectCard = (policy) => {
    setPolicySelected(policy);
    if (policySelected?.id === policy.id) {
      setSelected(!selected);
    } else {
      setSelected(false);
    }
  };

  useEffect(() => {
    dataLayerPush('cuenta_modificar_pago', user?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [open, setOpenWhatsappDialog] = useState(false);
  const validateCompany = () => {
    if (policySelected) {
      policySelected.provider?.company?.toLowerCase() === 'galicia'
        ? setOpenWhatsappDialog(true)
        : handleContinue();
    }
  };

  return (
    <>
      <Box display={loading || loadingP ? 'block' : 'none'}>
        <Loader action={'Cargando pólizas'}></Loader>
      </Box>

      <WhatsappDialog
        is_open={open}
        close_dialog={() => setOpenWhatsappDialog(false)}
        message={`En este momento no podemos mostrarte la información de tu póliza.
        Podés seguir operando vía Whatsapp.`}
      >
        {' '}
      </WhatsappDialog>

      {listProducts ? (
        <Products
          filterProduct={filterProduct}
          finishSelection={finishSelection}
        />
      ) : (
        <>
          <SubHeader
            content={
              <Box>
                <Typography variant="h6">
                  {' '}
                  ¿Qué póliza querés modificar?{' '}
                </Typography>
              </Box>
            }
            goBack={() => setListProducts(true)}
          ></SubHeader>

          <Grid container justify="center">
            <Grid item xs={11}>
              <Box>
                <Grid container>
                  <Grid item xs={12}>
                    <Box my={2}>
                      <Typography></Typography>
                    </Box>
                  </Grid>

                  {policies?.length
                    ? policies.map((policy: any, index: number) => (
                        <Grid item xs={12} sm={6} key={index}>
                          <Box mx={1} my={1} className={classes.selectionCard}>
                            <Box m={1} onClick={() => selectCard(policy)}>
                              <SuraCard
                                className={
                                  classes.selectionCard +
                                  (policySelected?.id === policy.id
                                    ? ' ' + classes.borderedCard
                                    : '')
                                }
                              >
                                <Box
                                  m={2}
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="center"
                                  width="100%"
                                >
                                  <Box
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="flex-start"
                                    flexDirection="column"
                                  >
                                    <Box>
                                      <Typography display="inline">
                                        {' '}
                                        Póliza {policy.number}{' '}
                                      </Typography>
                                      <Box mt={1}>
                                        <Typography
                                          color="secondary"
                                          variant="subtitle2"
                                        >
                                          {policy.vehicles.length > 10 ? (
                                            <Accordion defaultExpanded square>
                                              <AccordionSummary
                                                // expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                              >
                                                FLOTA
                                              </AccordionSummary>
                                              <AccordionDetails>
                                                <Typography
                                                  color="secondary"
                                                  variant="subtitle2"
                                                >
                                                  {policy.vehicles?.map(
                                                    (vehicle: any) =>
                                                      vehicle.license_plate +
                                                        ' ' || ''
                                                  )}
                                                </Typography>
                                              </AccordionDetails>
                                            </Accordion>
                                          ) : !policy.vehicles.length ? (
                                            policy.product.description
                                          ) : (
                                            <div>
                                              Patente:{' '}
                                              {
                                                policy.vehicles[0]
                                                  ?.license_plate
                                              }
                                            </div>
                                          )}
                                        </Typography>
                                      </Box>
                                    </Box>
                                  </Box>
                                  <Box>
                                    {policy.vehicles.length < 10 && (
                                      <Checked></Checked>
                                    )}
                                  </Box>
                                </Box>
                              </SuraCard>
                            </Box>
                          </Box>
                        </Grid>
                      ))
                    : 'No tenés pólizas para los ramos seleccionados'}
                </Grid>
              </Box>
            </Grid>
          </Grid>
          <Grid container justify="center">
            <Grid
              item
              justify="center"
              xs={11}
              md={7}
              style={{
                display: 'flex',
                marginTop: '2rem',
                marginBottom: '3rem',
              }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={validateCompany}
                disabled={!policySelected?.id}
              >
                Continuar
              </Button>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default ModifiedPayments;
